import { useCallback } from 'react'
import { updateFormData, nextStage } from '../../../../store/claim_work/action-creators'
import { isFormDataRequired } from '../../../../../lib/utils/collections'
import { Modal } from 'antd'
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch'
import { getStageCodeFromFormStages } from '../../../../lib/stage-conflict'

export function useSaveResult() {
  const dispatch = useAppDispatch()

  const saveResult = useCallback(
    async (id, visibleFormData, stage = undefined, isNextStage = false, stages?) => {
      if (!visibleFormData) {
        return
      }

      const formData = { ...visibleFormData.resultObject }
      if (Object.keys(formData).length === 0) {
        console.log('empty formData', formData)
        return
      }
      if (isNextStage) {
        const isRequiredFields = isFormDataRequired(formData, visibleFormData.resultSchema)
        console.log({ isRequiredFields, formData, resultSchema: visibleFormData.resultSchema })
        if (!isRequiredFields) {
          Modal.warning({
            title: 'Предупреждение',
            content: 'Заполните все обязательные поля',
          })
          return
        }
        const from_stage = getStageCodeFromFormStages(stages)
        dispatch(nextStage(id, { ...formData, stage, ...(from_stage ? { from_stage } : {}) }))
      } else {
        dispatch(updateFormData(id, formData))
      }
    },
    [dispatch],
  )
  return { saveResult }
}
